import React, { useEffect, useState } from 'react';
import { PagingQuery } from 'tea-component';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { RetentionDetailMetricColumn } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/RetentionCloums';
import SensorTowerIcon from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';
import { useIntl } from 'umi';
import { sortTableByMetric } from '@/pages/intelligence/utils/tableUtils';
import FirstRowEdition from '@/pages/intelligence/components/TableComponents/components/FirstRowEdition';
import { pageAble } from '@/pages/intelligence/utils/commonUtils';
import TopchartTable from '@/pages/intelligence/components/TableComponents/TopchartTable';

const ChannelsCard = (props: any) => {
  const {
    tableData = [],
    unPublishedAppIdList,
    chartSegment,
    tableHeaderOptions,
    fixedTableData,
    entityType,
    gameName,
    gameCover,
    dateType,
    startDate,
    endDate,
    onTableSortChage,
    pageSortAttr: defaultPageSortAttr,
    retentionMetricSource = 'appannie',
  } = props;

  const { formatMessage } = useIntl(); // 中英切换方法
  const [sortTableData, setSortTableData] = useState(tableData);
  const [pageSortTable, setPageSortTable] = useState<any[]>([]);
  const [pageSortAttr, setPageSortAttr] = useState(defaultPageSortAttr);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  useEffect(() => {
    onSortChage({
      sortMetric: defaultPageSortAttr?.currentSortMetric,
      sortVal: defaultPageSortAttr?.currentSortValue,
      ratioType: defaultPageSortAttr?.currentRatioType,
    })
    setPageSortAttr(defaultPageSortAttr)
  }, [tableData, defaultPageSortAttr]);

  const handleSortChange = (e: SortByItemType) => {
    onTableSortChage?.(e);
    onSortChage(e);
  }

  const getSortParams = (e: SortByItemType) => ({
    sortMetric: e.sortMetric || '',
    sortVal: e.sortVal === 'asc' ? 'asc' : 'desc' as 'asc' | 'desc',
    ratioType: (e.ratioType === 1 ? 1 : 0) as 0 | 1,
  });

  const onSortChage = (e: SortByItemType) => {
    const sortParams = getSortParams(e);
    setPageSortAttr({
      currentSortValue: sortParams.sortVal,
      currentSortMetric: sortParams.sortMetric,
      currentRatioType: sortParams.ratioType,
    });
    const sortTable = sortTableByMetric({
      tableData: tableData,
      sortParams,
      timeProperty: 'date',
      metricProperty: 'name',
      growthProperty: 'dod',
    });
    const pageList: any[] = pageAble(sortTable, pageIndex, pageSize);
    setPageSortTable([...(fixedTableData || []), ...(pageList || [])]);

    setSortTableData(sortTable.slice(0));
  };

  const onPagingChange = (e: PagingQuery) => {
    setPageIndex(e.pageIndex || 1);
    setPageSize(e.pageSize || 5);
    // onTablePagingChange(e);
    const pageList = pageAble(sortTableData, e.pageIndex || 1, e.pageSize || 5);
    setPageSortTable([...(fixedTableData || []), ...(pageList || [])]);
  };

  const isSensorTowerMonthly = retentionMetricSource === 'sensortower';

  const getRetentionDayOrdinal = (metricKey: string) => {
    const day = Number(String(metricKey || '').replace(/^D/i, ''));
    if (!day) return metricKey;
    const suffix = day % 10 === 1 && day % 100 !== 11
      ? 'st'
      : day % 10 === 2 && day % 100 !== 12
        ? 'nd'
        : day % 10 === 3 && day % 100 !== 13
          ? 'rd'
          : 'th';
    return `${day}${suffix}`;
  };

  const getMetricCloums = () => {
    const metricCloums: any[] = [];
    //DAU Revenue Download 每个数据源赋值一遍
    tableHeaderOptions.forEach((t: any) => {
      metricCloums.push(
        RetentionDetailMetricColumn({
          dataSource: isSensorTowerMonthly ? 'sensortower' : 'appannie',
          title: t.title,
          svgIcon: isSensorTowerMonthly ? SensorTowerIcon : undefined,
          textContent: isSensorTowerMonthly ? (
            <span style={{ whiteSpace: 'pre-line' }}>
              {formatMessage(
                { id: 'dbi_retention_monthly_sensortower_avg_dx_hover' },
                { metric: t?.key, dayOrdinal: getRetentionDayOrdinal(t?.key) },
              )}
            </span>
          ) : (
            <>
              {formatMessage(
                { id: 'dbi_retention_edition_nd_info' },
                { dn: t?.key },
              )}
              <br />
              {formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
            </>
          ),
          key: `${t.key}`,
          metricKey: t?.metricKey || t?.key,
          sourceDataOfDom: isSensorTowerMonthly ? `Retention ${t?.key}` : undefined,
          sortMetric: t.key,
          currentSortValue: pageSortAttr?.currentSortValue,
          currentSortKey: `${pageSortAttr?.currentSortMetric}_${pageSortAttr?.currentRatioType}`,
          isNoDropdown: !(chartSegment === t.key),
          entityType,
          gameName,
          gameCover,
          dateType,
          startDate,
          endDate,
          onSortChage: handleSortChange,
        }),
      );
    });
    return metricCloums;
  };

  return (
    <>
      <TopchartTable
        //   verticalTop
        // bordered="all"
        loading={false}
        records={pageSortTable}
        tableTotal={sortTableData?.length}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPagingChange={onPagingChange}
        pageSizeOptions={[5, 10, 15]}
        className="dbi-mobileGames-details-table"
        columns={[
          {
            key: 'app_id',
            header: (
              <div className="stats-table-title">
                <span className="stats-table-title-text">
                  {formatMessage({ id: 'dbi_top_editions' })}
                </span>
                <span className="stats-table-title-subtext">
                  ({sortTableData?.length || 0})
                </span>
              </div>
            ),
            width: 300,
            align: 'left',
            render: (cvm: any) => {
              const isUnPublished = unPublishedAppIdList?.includes(cvm?.app_id);
              if (cvm?.name === 'Total') {
                return <>Total</>;
              }
              return (
                <FirstRowEdition
                  name={cvm?.name}
                  isUnPublished={isUnPublished}
                  platform={cvm?.platform}
                  imgSrc={cvm?.cover}
                />
              );
            },
          },
          ...getMetricCloums(),
        ]}
      // addons={[
      //   pageable({
      //     stateTextVisible: true,
      //     pageSizeVisible: sortTableData?.length > 5,
      //     pageIndexVisible: sortTableData?.length > 5,
      //     jumpVisible: sortTableData?.length > 5,
      //     endJumpVisible: sortTableData?.length > 5,
      //     pageSizeOptions: [5, 10, 15],
      //   }),
      //   scrollable({
      //     //   maxHeight: 580,
      //     // minWidth: 2500
      //     //     tHeaderList?.length > 3
      //     //       ? 220 * tHeaderList?.length + 300
      //     //       : 'auto',
      //   }),
      // ]}
      />
    </>
  );
};

export default ChannelsCard;
